import { useMemo } from "react";
import { faUndo } from "@fortawesome/free-solid-svg-icons/faUndo";
import { resources } from "@constants/hardcoded-strings";
import { LabelWidthTypes } from "@enums/label-width-types";
import { LayoutTypes } from "@enums/layout-types";
import { SelectOption } from "@idw-types/common";
import { ThemingGenericContentSlotValidationErrors } from "@idw-types/common/validation/common/theming-validation-errors";
import { AXNUILayoutHelpTextInner } from "@iddataweb/idw-common-ui/types";
import { SelectFormGroup } from "../../../../../../common/select-form-group/select-form-group";

type ContentSlotPredefinedFormHelpTextContainerProps = {
    layout: LayoutTypes;
    labelWidth: LabelWidthTypes;
    isDisabled: boolean;
    validationErrors: ThemingGenericContentSlotValidationErrors;
    predefinedHelpTextTypeOptions: Array<SelectOption>;
    selectedPredefinedFormHelpText: string;
    defaultPredefinedFormHelpText: string;
    updateFormContentSlotContentField: (contentField: Partial<AXNUILayoutHelpTextInner>) => void;
};

export const ContentSlotPredefinedFormHelpTextContainer = (props: ContentSlotPredefinedFormHelpTextContainerProps) => {
    const {
        layout,
        labelWidth,
        isDisabled,
        validationErrors,
        predefinedHelpTextTypeOptions,
        selectedPredefinedFormHelpText,
        defaultPredefinedFormHelpText,
        updateFormContentSlotContentField
    } = props;

    const handlePredefinedFormHelpTextTypeChange = (newValue: SelectOption) => {
        updateFormContentSlotContentField({ formHelpTextType: newValue.value });
    };

    const handleResetPredefinedFormHelpTextType = () => {
        updateFormContentSlotContentField({ formHelpTextType: defaultPredefinedFormHelpText });
    };

    const selectedPredefinedFormHelpTextTypeOption = useMemo(() => {
        if (selectedPredefinedFormHelpText) {
            return predefinedHelpTextTypeOptions.find(htt => htt.value === selectedPredefinedFormHelpText);
        }
        return null;
    }, [selectedPredefinedFormHelpText]);

    return (
        <div>
            <SelectFormGroup
                controlId={"predefined-form-help-text-type-select-input"}
                automationId={"predefined-form-help-text-type-select-input"}
                label={resources.pages.verificationServiceDetails.tabs.theming.subTabs.common.inputs.predefinedFormHelpTextType.label}
                ariaLabel={resources.pages.verificationServiceDetails.tabs.theming.subTabs.common.inputs.predefinedFormHelpTextType.label}
                disabled={isDisabled}
                isClearable={false}
                isRequired={true}
                isSearchable={false}
                layout={layout}
                labelWidth={labelWidth}
                onChange={handlePredefinedFormHelpTextTypeChange}
                options={predefinedHelpTextTypeOptions}
                selectedOption={selectedPredefinedFormHelpTextTypeOption}
                afterLabelTooltipText={resources.pages.verificationServiceDetails.tabs.theming.subTabs.common.inputs.predefinedFormHelpTextType.tooltip("pre form")}
                afterLabelIcon={isDisabled ? null : faUndo}
                afterLabelIconOnClick={handleResetPredefinedFormHelpTextType}
            />
            {validationErrors.predefinedHelpTextTypeError}
        </div>
    );
};